import React, { Component } from "react";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../common/api";
import ClientTable from "../../assets/js/ClientTabe"; // Импортируем новый компонент

const columns = [
  { field: "first_name", header: "Имя" },
  // { field: "last_name", header: "Фамилия" },
  { field: "phone", header: "Телефон" },
  { field: "email", header: "Email" },
  { field: "city", header: "Город" },
  { field: "house", header: "Дом" },
  { field: "apartment", header: "Квартира" },
  // { field: "verified", header: "Верифицирован" },
  { field: "user_registered_at", header: "Дата регистрации" },
];

export class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchClients();
  }

  fetchClients = () => {
    axios
      .get(BASE_URL + "site-users/", HEADERS)
      .then((res) => {
        this.setState({
          data: res.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Ошибка загрузки клиентов:", error);
        this.setState({
          error: "Не удалось загрузить данные клиентов",
          loading: false,
        });
      });
  };

  handleView = (row) => {
    console.log("Просмотр клиента:", row);
    // Логика просмотра
  };

  // handleEdit = (row) => {
  //   console.log("Редактирование клиента:", row);
  //   // Логика редактирования
  // };

  // handleDelete = (row) => {
  //   if (window.confirm(`Удалить клиента ${row.first_name} ${row.last_name}?`)) {
  //     console.log("Удаление клиента:", row);
  //     // Логика удаления
  //   }
  // };

  render() {
    const { data, loading, error } = this.state;

    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Загрузка...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return <div className="alert alert-danger m-3">{error}</div>;
    }

    return (
      <div className="container-fluid p-4">
        <ClientTable
          data={data}
          columns={columns}
          title="Клиенты сайта"
          onView={this.handleView}
          // onEdit={this.handleEdit}
          // onDelete={this.handleDelete}
        />
      </div>
    );
  }
}

export default Client;